import { createClient } from '@supabase/supabase-js';

let supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Prepend window.location.origin if it's a relative proxy path (e.g. /supabase)
if (supabaseUrl && !supabaseUrl.startsWith('http')) {
  supabaseUrl = `${window.location.origin}${supabaseUrl}`;
}

// Singleton pattern for the public Supabase client
if (!globalThis.supabaseInstance) {
  globalThis.supabaseInstance = createClient(supabaseUrl, supabaseAnonKey);
}
export const supabase = globalThis.supabaseInstance;

// DEV ONLY: Admin client that bypasses RLS for local testing.
// Lazily initialize admin client and store in global singleton to avoid warnings
export const supabaseAdmin = new Proxy({}, {
  get: (target, prop) => {
    if (!globalThis.supabaseAdminInstance) {
      const serviceRoleKey = import.meta.env.VITE_SUPABASE_SERVICE_ROLE_KEY;
      if (import.meta.env.DEV && serviceRoleKey) {
        globalThis.supabaseAdminInstance = createClient(supabaseUrl, serviceRoleKey, {
          auth: {
            persistSession: false,
            autoRefreshToken: false,
            detectSessionInUrl: false,
            storageKey: 'citados-admin-auth-token'
          }
        });
      } else {
        console.warn('supabaseAdmin accessed but SERVICE_ROLE_KEY is missing or not in DEV mode');
        return null;
      }
    }
    return globalThis.supabaseAdminInstance[prop];
  }
});

